import React from "react";
import "./style.css";

export default function Footer() {
  return (
    <footer className="st-Footer">
      <div className="sw-Inner_Standard">
        <div className="sw-FlexBox st-Footer_Bet st-Footer_Inner">
          <ul className="st-FooterNav">
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/terms">利用規約</a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/policy">
                プライバシーポリシー
              </a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/legals">
                特定商取引法に基づく表記
              </a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/expressions">
                反社会的勢力に対する基本方針
              </a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/invitations">
                勧誘に関する規定
              </a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://enjoyworks.jp" target="_blank">
                運営会社
              </a>
            </li>
            <li className="st-FooterNav_Item">
              <a href="https://hello-renovation.jp/contact">お問い合わせ</a>
            </li>
          </ul>
          <a
            href="https://www.facebook.com/HELLO.RENOVATION/"
            className="st-Footer_SnsLink-Facebook"
          >
            Facebook
          </a>
        </div>
        <small>
          <p className="sw-Copy">&copy;2018 ENJOYWORKS Co.,Ltd.</p>
        </small>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js